<template>
    <div class="card special-delivery-dates-creation-form">
        <div class="card-header font-weight-bold">Ajouter une date de livraison exceptionnelle</div>

        <div class="card-body">
            <div class="form-group row">
                <label class="col-4 col-form-label" for="delivery_date">Date de livraison</label>

                <bootstrap-datepicker class="col-4" id="delivery_date" name="delivery_date" format="dd/MM/yyyy" placeholder="Nouvelle date..." v-model="selectedDeliveryDate" required></bootstrap-datepicker>
            </div>

            <ErrorsZone :errors="loadErrors"></ErrorsZone>

            <div v-if="loading">
                <i class="fa fa-spin fa-spinner"></i> Chargement...
            </div>
            <template v-else-if="loaded">
                <label class="font-weight-bold">Cocher les clients à autoriser :</label>

                <template v-if="customers.length">
                    <table class="table table-bordered table-sm table-striped">
                        <thead>
                        <tr>
                            <th></th>
                            <th>Client</th>
                            <th>Jours de livraison habituels</th>
                            <th>Jour de fin de préparation</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="customer in customers" :key="'customer_' + customer.id">
                            <td>
                                <input
                                    type="checkbox"
                                    :id="'special_delivery_date_cb_customer_' + customer.id"
                                    v-model="selectedCustomers"
                                    :value="customer.id"
                                    :disabled="!customer.is_bakery_open"
                                >
                            </td>
                            <td>
                                <label :for="'special_delivery_date_cb_customer_' + customer.id">
                                    <small>{{ customer.type_label }}</small>
                                    <br>
                                    {{ customer.name }}
                                </label>
                            </td>
                            <td>
                                {{ customer.delivery_days.join(', ') }}
                            </td>
                            <td>
                                <div>{{ customer.end_preparation_day }}</div>
                                <div>{{ global.moment(customer.end_preparation_date).format('dddd Do MMMM YYYY') }}</div>
                            </td>
                            <td>
                                <div v-if="customer.is_bakery_open" class="bg-success text-white p-1">
                                    <i class="fa fa-check"></i> fabrication ouverte
                                </div>
                                <div v-else class="bg-danger text-white p-1">
                                    <i class="fa fa-times"></i> fabrication fermée
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <ErrorsZone :errors="sendErrors"></ErrorsZone>

                    <div class="justify-content-end">
                        <button type="button" class="btn btn-success mb-2" :disabled="sending" @click="submit">
                            <i class="fad fa-fw fa-save"></i> Ajouter
                        </button>
                    </div>
                </template>
                <div v-else>
                    Aucun client trouvé.
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import ErrorsZone from "../ErrorsZone";
import {usePostRequest} from "../compositions/axios/postRequest";
import {useGetLoader} from "../compositions/axios/loadingRequest"
import {momentDayFormatYmd} from "../../moment-with-helpers";

export default {
    props: {
        loadCustomersAction: {
            type: String,
            required: true,
        },
        postAction: {
            type: String,
            required: true,
        }
    },

    components: {
        ErrorsZone,
    },

    setup(props) {
        const {
            loading: sending,
            errors: sendErrors,
            post: send,
        } = usePostRequest();

        const {
            loading,
            loaded,
            errors: loadErrors,
            load,
        } = useGetLoader();

        return {
            loading,
            loaded,
            loadErrors,
            load,

            sending,
            sendErrors,
            send,
        };
    },

    data() {
        return {
            selectedDeliveryDate: null,
            selectedCustomers: [],
            customers: [],
        }
    },

    watch: {
        async selectedDeliveryDate(newValue, oldValue) {
            if (oldValue !== newValue) {
                this.customers = [];
                if (newValue) {
                    const response = await this.load(
                        route(this.loadCustomersAction, {
                            deliveryDateYmd: momentDayFormatYmd(this.selectedDeliveryDate),
                        })
                    );
                    if (response) {
                        this.customers = response;
                        this.selectedCustomers = this.customers
                            .filter(function (customer) {
                                return customer.is_allowed_delivery_day;
                            })
                            .map(function (customer) {
                                return customer.id;
                            });
                    }
                }
            }
        },
    },

    methods: {
        async submit() {
            let response = await this.send(this.postAction, {
                delivery_date: momentDayFormatYmd(this.selectedDeliveryDate),
                customers: this.selectedCustomers,
            });

            if (response && response.success) {
                window.location.hash = '#special_delivery_dates';
                window.location.reload();
            }
        },
    },
}
</script>
